"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
var _uuid = require("uuid");
var _common = require("../../common");
var _jsxRuntime = require("react/jsx-runtime");
const rotating = (0, _mui.keyframes)`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const LoadingRoot = (0, _mui.styled)('svg', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})({
  animation: `${rotating} 1s infinite linear`
});
const Loading = () => {
  const id = (0, _uuid.v4)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(LoadingRoot, {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    "data-testid": _common.LOADING,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("linearGradient", {
        id: `spinner-fill-${id}`,
        x1: "-0.019",
        y1: "0.75",
        x2: "0.911",
        y2: "0.887",
        gradientUnits: "objectBoundingBox",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "0",
          stopColor: _mui.theme.palette.secondary.main,
          stopOpacity: "0"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("stop", {
          offset: "1",
          stopColor: _mui.theme.palette.secondary.main
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      style: {
        fillRule: 'evenodd',
        fill: `url(#spinner-fill-${id})`
      },
      d: "M20.412,962.766a10.224,10.224,0,0,0-10.009,10,11.959,11.959,0,0,0,.1,1.425c.187,1.222.849,1.508,1.4,1.46a.985.985,0,0,0,.7-.365,1.092,1.092,0,0,0,.191-.886c-.013-.057-.018-.12-.026-.174a7.667,7.667,0,0,1-.156-1.46,7.782,7.782,0,1,1,5.074,7.3,1.108,1.108,0,1,0-.877,2.033,9.043,9.043,0,0,0,3.606.669,9.988,9.988,0,0,0,9.991-10A10.317,10.317,0,0,0,20.412,962.766Z",
      transform: "translate(-10.403 -962.766)"
    })]
  });
};
exports.Loading = Loading;
//# sourceMappingURL=Loading.js.map